import { MibeModel } from './mibemodel.model';

export class PlaylistClient implements MibeModel {
  id: number;
  name: string;

  private _original_data: any;

  /**
   * Create a Playlist.
   * @param {any} json - The JSON object with which to construct our Playlist.
   */
  constructor(json:any) {
    this.loadWithJSON(json);
  }
  /**
   * Load a Playlist.
   * @param {any} json - The JSON object with which to load our Playlist.
   */
  loadWithJSON(json: any) {
    if (!json) {
      return;
    }
    this._original_data = json;
    this.id = json.id;
    this.name = json.name && json.name?.replace(/ {2,}/g, ' ');
  }
  /**
   * Returns a JSON representation of our Playlist
   * @return {any} - The JSON representation of our Playlist
   */
  toJSON() {
    var json = this._original_data;
    json['id'] = this.id;
    json['name'] = this.name;
    return json;
  }

}
